// Maltese translations.
// ⚠️ Many strings need native-speaker review — see /app/memory/I18N_MT_REVIEW.md for the flagged list.
// Missing keys fall back to English automatically (see /app/frontend/src/lib/i18n/index.js).

const mt = {
  nav: {
    howItWorks: "Kif jaħdem",
    features: "Funzjonijiet",
    updates: "Aġġornamenti",
    useSpotDrop: "Uża SpotDrop",
    langLabel: { en: "Ingliż", mt: "Malti", it: "Taljan (Italiano)" },
  },
  hero: {
    badge: "Attiv f'Malta",
    headline: "Sib il-parking qabel jgħib.",
    sub: "Postijiet tal-parking f'ħin reali, imħollijin u meħudin mis-sewwieqa madwar Malta. Erħi l-post tiegħek meta titlaq, sib wieħed meta ma jkollokx.",
    ctaPrimary: "Uża SpotDrop",
    ctaSecondary: "Kif jaħdem",
    ctaPlayAlt: "Niżżlu minn Google Play",
    ctaPlayNote: "App Android · bla ħlas",
    ctaInstallWeb: "Installa l-Web App",
    trust: { free: "Bla ħlas", malta: "Magħmul għal Malta", nosignup: "Bla reġistrazzjoni" },
  },
  how: {
    eyebrow: "Kif jaħdem",
    title: "Tliet passi sempliċi għal kull sewwieq f'Malta.",
    subtitle: "Sew jekk qed titlaq jew qed tfittex.",
    card1: { tag: "01 · Erħi", title: "Ser titlaq minn post?", desc: "Erħi l-post tal-parking tiegħek qabel titlaq biex is-sewwieq li jmiss ikun jista' jieħdu mill-ewwel." },
    card2: { tag: "02 · Sib", title: "Qed tfittex il-parking?", desc: "Ara l-postijiet tal-parking jinfetħu fuq il-mappa live madwarek fis-sekonda li s-sewwieqa jħallu l-post." },
    card3: { tag: "03 · Skambju", title: "Se tiltaqa' mas-sewwieq li jmiss?", desc: "Agħżel \"Nista' nistenna\" jew \"Ma nistax nistenna\" biex is-sewwieq li ġej ikun jaf x'jistenna — skambji ċari u onesti." },
  },
  features: {
    eyebrow: "Funzjonijiet",
    title: "Mibnija bħal grilja ta' parking Maltija.",
    tag: "Iddiżinjata għas-sewwieqa ta' kuljum",
    card1: { title: "Mappa live f'ħin reali", desc: "Ara l-postijiet jidhru fuq il-mappa fil-mument li s-sewwieqa jħallu post ħdejk." },
    card2: { title: "Sistema tal-lokazzjoni intelliġenti", desc: "Preċiżjoni mfassla għat-toroq dojoq ta' Malta." },
    card3: { title: "Postijiet Blue Badge, Loading u Mutur", desc: "Erħi u sib postijiet Normali, Blue Badge, Loading u tal-Muturi — irrispetta r-regoli lokali." },
    card4: { title: "Ftakar fejn ipparkjajt", desc: "Ħażen il-lokazzjoni tal-parking tiegħek u iftaħ id-direzzjonijiet bil-mixi lura lejn il-karozza." },
    card5: { title: "Malajr u sempliċi", desc: "Żewġ tektikiet biex terħi. Żewġ tektikiet biex tieħu. Daqshekk." },
    card6: { title: "Immexxija mill-komunità", desc: "Kull sewwieq f'Malta jagħmel in-netwerk aktar intelliġenti." },
  },
  showcase: {
    eyebrow: "Ġewwa l-app",
    title: "Ħjiel ta' SpotDrop.",
    sub: "Tliet skrins. Missjoni waħda — qatt aktar ma ddurx tfittex il-parking.",
    ctaCopy: "SpotDrop huwa attiv f'Malta. Iftħu u ipprovaha.",
    ctaBtn: "Uża SpotDrop",
    liveNow: "Attiv bħalissa",
    liveTitle: "Funzjonijiet li tista' tuża llum",
    live1: { title: "Assistent tal-Parking", desc: "Għidlu fejn sejjer — isib l-aħjar parking fil-viċin u jmexxik bil-mixi.", cta: "Sib parking" },
    live2: { title: "Ħażen il-Karozza", desc: "Ħażen fejn ipparkjajt u ikseb direzzjonijiet bil-mixi lura lejha.", cta: "Ħażen il-karozza" },
    live3: { title: "Postijiet tal-komunità", desc: "Is-sewwieqa jerħu l-post tagħhom meta jitilqu, biex tieħu wieħed mingħajr ma tiddur.", cta: "Ara l-postijiet attivi" },
    mockup1: { tag: "01 · Mappa live", title: "Parking f'ħin reali", liveSpots: "Postijiet attivi", leavingIn5: "Se nitlaq f'5 min", leavingIn10: "Se nitlaq f'10 min" },
    mockup2: {
      tag: "02 · Erħi", title: "Se nitlaq minn post", leavingLabel: "Se nitlaq fi",
      min5: "5 min", min10: "10 min", min15: "15 min",
      hint: "Sewwieqa ħdejk se jarawh fuq il-mappa", dropBtn: "Erħi l-post",
      doneTitle: "Post imħolli", doneSub: "Sewwieqa ħdejk jistgħu jaraw il-post tiegħek fuq il-mappa.",
    },
    mockup3: {
      tag: "03 · Skambju", title: "Nista' nistenna / Ma nistax nistenna",
      headerTitle: "Skambju", arrivingLabel: "Sewwieq wasal",
      arrivingName: "Luca · Fiat 500 Bajda", arrivingMeta: "Plakka JFK-224 · 120m 'il bogħod",
      prompt: "Tista' tistenna?", subprompt: "Għidilhom x'jistgħu jistennew",
      canWait: "Nista' nistenna", canWaitDesc: "Nibqa' hemm sakemm jasal Luca.",
      cantWait: "Ma nistax nistenna", cantWaitDesc: "Se nitlaq issa — l-ewwel sewwieq jeħodh.",
      footer: "Skambji onesti jżommu l-mappa ġusta għal kulħadd.",
    },
  },
  roadmap: {
    eyebrow: "Roadmap",
    title: "X'qed nibnu jmiss.",
    sub: "Ħjiel tal-affarijiet li qed naħdmu fuqhom. Naddaħħlu triq waħda kull darba.",
    chipLive: "Attiv",
    chipSoon: "Dalwaqt",
    footnote: "Elementi tar-roadmap, mhux impenn. SpotDrop hi pjattaforma ta' informazzjoni u komunità — il-parking pubbliku qatt mhu rriżervat jew iggarantit.",
    item1: { title: "Erħi post tal-parking", desc: "Aqsam il-post tiegħek fil-mument li titlaq." },
    item2: { title: "Ħu post", desc: "Ħu post miftuħ fuq il-mappa live qabel ma jasal ħaddieħor." },
    item3: { title: "Kiri ta' parking privat", desc: "Postijiet ta' kull xahar mingħand sidien verifikati." },
    item4: { title: "Ħażen il-lokazzjoni tal-karozza tiegħi", desc: "Qatt aktar ma titlifx fejn ipparkjajt." },
    item5: { title: "Żoni favoriti", desc: "Twissijiet intelliġenti għat-toroq li jimpurtawk." },
    item6: { title: "Punti u reputazzjoni tal-komunità", desc: "Ippremja lil dawk li jikkontribwixxu attivament u ta' fiduċja." },
    item7: { title: "Protezzjoni kontra l-ispam u l-bots", desc: "Sewwieqa veri, postijiet veri." },
    item8: { title: "Modalità Avvenimenti / Bajja / Festival", desc: "Kixef l-affollament għall-festi, il-festivals u l-jiem tal-bajja." },
    item9: { title: "Appoġġja SpotDrop", desc: "Bla ħlas għall-komunità. Appoġġ mhux obbligatorju biex ngħinuk intejbu." },
    item10: { title: "Pjan tas-supporters (futur)", desc: "Vantaġġi mhux obbligatorji biex tappoġġja l-proġett." },
  },
  updates: {
    eyebrow: "Aġġornamenti",
    title: "Irċievi aġġornamenti",
    sub: "SpotDrop huwa attiv u bla ħlas. Ħalli l-email tiegħek jekk trid tirċievi xi aġġornamenti kultant — funzjonijiet ġodda, aġġornamenti ta' kopertura, u aħbarijiet importanti ta' SpotDrop.",
    field: {
      name: "Ismek", namePlaceholder: "Alex",
      email: "Email", emailPlaceholder: "[email protected]",
      area: "Żona f'Malta", areaPlaceholder: "Sliema, San Ġiljan, il-Belt…",
    },
    submit: "Ikseb l-aġġornamenti",
    submitting: "Qed nissottoskrivi...",
    successTitle: "Int fuq il-lista tal-aġġornamenti.",
    successBody: "Ħażniet l-email tiegħek. Se nibagħtu biss xi aħbarijiet minn SpotDrop kultant.",
    alreadyOn: "Int diġà fuq il-lista tal-aġġornamenti.",
    alreadyBody: "Din l-email diġà ħażnitna. Se nibagħtu biss xi aħbarijiet minn SpotDrop kultant.",
    launchNote: "Attiv f'Malta · Bla ħlas",
  },
  footer: {
    tagline: "In-netwerk tal-parking immexxi mill-komunità għal Malta.",
    updates: "Irċievi aġġornamenti",
    terms: "Termini",
    privacy: "Privatezza",
    disclaimer: "Ċaħda",
    instagramAlt: "Segwi SpotDrop fuq Instagram",
    copyright: "© {year} SpotDrop Malta. Kull dritt riżervat.",
  },
  legal: {
    terms: {
      title: "Termini tal-Użu",
      intro: "Dawn it-termini jirregolaw l-użu tiegħek ta' SpotDrop. Jekk jogħġbok aqrahom qabel tuża s-servizz.",
      notice: "Dan id-dokument bħalissa jinżamm bl-Ingliż. Verżjoni tradotta ġejja dalwaqt.",
    },
    privacy: {
      title: "Politika ta' Privatezza",
      intro: "Aħna nieħdu l-privatezza tiegħek bis-serjetà. Hawn kif SpotDrop tittratta d-data tiegħek.",
      notice: "Dan id-dokument bħalissa jinżamm bl-Ingliż. Verżjoni tradotta ġejja dalwaqt.",
    },
    disclaimer: {
      title: "Ċaħda",
      intro: "SpotDrop hi pjattaforma ta' informazzjoni u komunità. Il-parking pubbliku qatt mhu rriżervat jew iggarantit.",
      notice: "Dan id-dokument bħalissa jinżamm bl-Ingliż. Verżjoni tradotta ġejja dalwaqt.",
    },
  },
  common: { close: "Agħlaq", cancel: "Ikkanċella", back: "Lura", save: "Ħażen", language: "Lingwa", active: "Attiv" },
};

export default mt;
